import { LiveChatState } from "@moodys/mdc-frontend.utils.event-bus";

type WindowWithLiveagent = Window & {
  // window.liveagent is set up by Salesforce and there are no types available
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  liveagent: any;
};

export const isLiveagentInWindow = (
  window: Window
): window is WindowWithLiveagent => {
  return "liveagent" in window;
};

declare global {
  interface Window {
    _laq?: unknown[];
    liveagent?: unknown;
  }
}

export type InitLiveChatArgs = {
  insiteId: string;
  handleChatAvailabilityState: (data: LiveChatState | undefined) => void;
};
